




import { pageFactory } from '@/main/pages/pageFactory';
import { pageStoreBuilder } from '@/main/store/pages/page/builder';

const name = 'LeadyListIframe';

export default pageFactory(name, pageStoreBuilder({
	name,
	crumbLabel: 'CRM_Leady',
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
}));
